import { render, staticRenderFns } from "./TenderOffersLegend.vue?vue&type=template&id=f840aa54&"
import script from "./TenderOffersLegend.vue?vue&type=script&lang=js&"
export * from "./TenderOffersLegend.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports